<template>
  <button
    type="button"
    class="btn-next"
    :disabled="internalDisabled"
    :aria-label="nextText || t('lt.pagination.next')"
    :aria-disabled="internalDisabled"
    @click="$emit('click', $event)"
  >
    <span v-if="nextText">{{ nextText }}</span>
    <lt-icon v-else>
      <component :is="nextIcon" />
    </lt-icon>
  </button>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { LtIcon } from '@lit-element/components/icon'
import { useLocale } from '@lit-element/hooks'
import { paginationNextProps } from './next'

defineOptions({
  name: 'LtPaginationNext',
})

const props = defineProps(paginationNextProps)

defineEmits(['click'])

const { t } = useLocale()

const internalDisabled = computed(
  () =>
    props.disabled ||
    props.currentPage === props.pageCount ||
    props.pageCount === 0
)
</script>
